import {userService} from "./auth/services";
import {alertActions} from "./alert/actions";
import alertify from "alertifyjs";
export const configService = {
    handleResponse,
    handleApiError
}

/**
 *
 * @param response
 * @returns {Promise<never>|*}
 */
function handleResponse(response) {
    switch (response.status) {
        case 500:
            console.log(response.statusText);
            return Promise.reject('Something went wrong. Please try again later.');
        case 401:
            // userService.logout();
            // window.location.reload(true);
            return Promise.reject('Unauthorized access. Please log in again.');
        default:
            return response.data;
    }
}


/**
 * Handle api errors
 * @param errorResponse
 * @returns {Promise<never>}
 */
// function handleApiError(errorResponse) {
//     // console.log(errorResponse)
//     //console.log(errorResponse.response);
//     let response = errorResponse.response;
//     let errorMessage = 'Something went wrong please try again later.';

//     if (response && response.status == 422) {

//         //dispatch(alertActions.error(response.data.message));
//         errorMessage = response.data.message;
//         if(typeof response.data.errors == 'object'){

//             let msg = '';
//             for (let [key, value] of Object.entries(response.data.errors)) {
//                 msg += value + '<br />';
//             }
//             errorMessage = msg;
//         }
//     } else if (response && response.status == 500) {
//         errorMessage = 'Something went wrong please try again later.'
//     } else if (response && response.status == 401) {
//         errorMessage = 'Please login to proceed.'
//     }else if (response && response.status == 503) {
//         errorMessage = 'Service unavailable. Please try again later.'
//     }
//     return Promise.reject(errorMessage);
//     // alertify.error(errorMessage);
// }


let isRefreshing = false;
let refreshPromise = null;

async function handleApiError(errorResponse) {
    const response = errorResponse.response;
    let errorMessage = 'Something went wrong. Please try again later.';

    if (response && response.status === 422) {
        errorMessage = response.data.message;
        if (typeof response.data.errors === 'object') {
            let msg = '';
            for (let [key, value] of Object.entries(response.data.errors)) {
                msg += value + '<br />';
            }
            errorMessage = msg;
        }
    } else if (response && response.status === 500) {
        errorMessage = 'Something went wrong. Please try again later.';
    } else if (response && response.status === 503) {
        errorMessage = 'Service unavailable. Please try again later.';
    } else if (response && response.status === 401) {
        // Refresh token logic
        if (!isRefreshing) {
            isRefreshing = true;
            refreshPromise = userService.refreshAccessToken()
                .then((newToken) => {
                    localStorage.setItem('token', newToken.token);
                    localStorage.setItem('refreshtoken', newToken.refresh_token);
                    return newToken;
                })
                // .catch((refreshError) => {
                //     // Logout or redirect to login
                //     localStorage.removeItem('token');
                //     localStorage.removeItem('refreshtoken');
                //     // Optionally redirect or dispatch logout
                //     return Promise.reject('Session expired. Please login again.');
                // })
                .finally(() => {
                    isRefreshing = false;
                });
                // window.location.reload(true);
        }

        // Wait for the refresh to complete (shared across callers)
        return refreshPromise.then(() => {
            // Optionally retry original request here
            // For now, just reject to trigger UI flow
            return Promise.reject('Token refreshed. Please retry your request.');
        });
    }

    return Promise.reject(errorMessage);
}